import { useMemo } from 'react';
import { useViewportDimensions } from '../../../../common/utilities/dimensions.hook';
import {
  SCROLL_CONTAINER_MAX_HEIGHT,
  SCROLL_ROW_HEIGHT,
  useSlicerTheme,
} from '.';
import { min } from 'lodash';

const MINIMUM_VIEWPORT_HEIGHT = 295;
const MINIMUM_HEIGHT_OFFSET = 250;
const DASHLET_MINIMUM_HEIGHT_OFFSET = 190;

interface ISlicerDimensionsProps {
  optionsLength: number;
  slicerErrorVisible: boolean;
  isDashletTag?: boolean;
}

interface ISlicerDimensionsResult {
  height: number;
  width: number;
}

export const useSlicerDimensions = ({
  optionsLength,
  slicerErrorVisible,
  isDashletTag,
}: ISlicerDimensionsProps): ISlicerDimensionsResult => {
  const {
    isMobile,
    isDashletMode,
    width: _width,
    listHeight,
  } = useSlicerTheme();
  const { height: windowHeight } = useViewportDimensions();
  const calcHeight = optionsLength * SCROLL_ROW_HEIGHT;
  let height = windowHeight;

  if (isDashletMode && !isDashletTag) {
    height =
      windowHeight -
      (windowHeight < MINIMUM_VIEWPORT_HEIGHT
        ? DASHLET_MINIMUM_HEIGHT_OFFSET
        : MINIMUM_HEIGHT_OFFSET);
  } else if (isMobile && !isDashletTag) {
    height = windowHeight - 300;
  } else {
    height = min([SCROLL_CONTAINER_MAX_HEIGHT, calcHeight, listHeight]);
  }

  if (isMobile && slicerErrorVisible) {
    height = windowHeight - 295;
  }

  const isScrolling = calcHeight > SCROLL_CONTAINER_MAX_HEIGHT;
  const width = useMemo(
    () => (isScrolling ? _width - 12 : _width),
    [_width, isScrolling],
  );

  return {
    height,
    width,
  };
};
